import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { EmailAlertStatusService } from './services/email-alert-status-service';
import { EmailAlertStatusServiceRepository } from './repositories/email-alert-status-service-repository';
import { EmailAlertStatusApi } from './apis/email-alert-status-api';
import { EmailAlertStatusApiImpl } from './apis/impls/email-alert-status-api';
export const toolbar = new ContainerModule(bind => {
    bind(EmailAlertStatusService).to(EmailAlertStatusServiceRepository);
    bind(EmailAlertStatusApi).to(EmailAlertStatusApiImpl);
});
